import { useAuthContext } from "@/features/authentication/useAuthContext";
import { BrandLoader } from "@/components/BrandLoader";
import { type ReactNode } from "react";
import { Navigate } from "react-router";

export const AuthenticatedRouteGuard = ({
    children
}: {
    children: ReactNode;
}): ReactNode => {
    const { user, loading, approved } = useAuthContext();

    if (loading) return <BrandLoader fullScreen />;

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Signed in but the allowlist check is still in flight (e.g. just after a
    // fresh sign-in) — hold rather than flash the wrong branch.
    if (approved === null) return <BrandLoader fullScreen />;

    if (approved === false) {
        return <Navigate to="/pending" replace />;
    }

    return children;
};
